import { FC } from 'react'
import PerFlexRow from '../../FlexRow'
import PerText from '../../Text'
import TrueFalseSwitch from '../../TrueFalseSwitch'

import '../index.less'

type Props = {
  label: string
  onValueChanged: (value: boolean) => void
  currentValue?: boolean
  disabled?: boolean
}

export const PerInfoBoxTrueFalseElement: FC<Props> = ({ label, onValueChanged, currentValue, disabled }) => {
  return (
    <PerFlexRow align="middle" justify="center" direction="column" className="per-infoBox--tagElement">
      <PerText appearance="label-small" align="center" mb="s">
        {label}
      </PerText>
      <TrueFalseSwitch onValueChanged={onValueChanged} currentValue={currentValue} disabled={disabled} />
    </PerFlexRow>
  )
}
